import { render, staticRenderFns } from "./CriticalAddressSketch.vue?vue&type=template&id=098da5f8&scoped=true"
import script from "./CriticalAddressSketch.vue?vue&type=script&lang=js"
export * from "./CriticalAddressSketch.vue?vue&type=script&lang=js"
import style0 from "./CriticalAddressSketch.vue?vue&type=style&index=0&id=098da5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098da5f8",
  null
  
)

export default component.exports